// extracted by mini-css-extract-plugin
export default {"menuModalWrapper":"MenuModal-module--menu-modal-wrapper--dd2c9"};